<template>
  <div>
    <section class="hero is-danger">
      <h3 class="is-size-3">{{ title }}</h3>
    </section>
    <section class="section">
      <div class="container">
        <div v-if="isErrors">
          <p class="hero">
            <span class="has-text-danger">{{ isErrors }}</span>
          </p>
        </div>
        <form @submit.prevent="onSubmit">
          <!-- 1行目 -->
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="lable">タイトル</label>
            </div>
            <div class="field-body">
              <div class="field">
                <p class="control">
                  <input
                    class="input"
                    v-model="inputForm.title"
                    type="text"
                    placeholder="タイトル"
                    required
                  />
                </p>
              </div>
            </div>
          </div>
          <!-- 1行目 end -->
          <!-- 2行目 -->
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="lable">グループ</label>
            </div>
            <div class="field-body">
              <div class="field is-narrow">
                <div class="control">
                  <div class="select">
                    <select v-model="inputForm.group">
                      <option value="0">選択してください</option>
                      <option
                        v-for="group in groups"
                        v-bind:value="group.id"
                        v-bind:key="group.id"
                      >{{ group.name }}</option>
                    </select>
                  </div>
                </div>
                <h6 class="h7 is-size-7 has-text-danger" v-show="error.group">※リストから項目を選択してください</h6>
              </div>
            </div>
          </div>
          <!-- 2行目 end  https://bulma.io/documentation/form/general/ -->
          <!-- 3行目 -->
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="lable">カテゴリ</label>
            </div>
            <div class="field-body">
              <div class="field is-narrow">
                <div class="control">
                  <div class="select">
                    <select v-model="inputForm.category">
                      <option value="0">選択してください</option>
                      <option
                        v-for="category in categorys"
                        v-bind:value="category.id"
                        v-bind:key="category.id"
                      >{{ category.name }}</option>
                    </select>
                  </div>
                </div>
                <h6 class="h7 is-size-7 has-text-danger" v-show="error.category">※リストから項目を選択してください</h6>
              </div>
            </div>
          </div>
          <!-- 3行目 end -->
          <!-- 4行目 -->
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="lable">本文</label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <vue-editor v-model="inputForm.letter" :editor-toolbar="customToolbar"></vue-editor>
                  <!-- <textarea class="textarea" v-model="inputForm.letter" placeholder="本文" required></textarea> -->
                </div>
              </div>
            </div>
          </div>
          <!-- 4行目 end -->
          <!-- 5行目 -->
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label"></label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="box">
                  <img
                    v-show="imageSrc"
                    class="preview-item-file is-16by9"
                    :src="imageSrc"
                    alt="画像"
                  />
                  <div class="block" v-if="imageSrc">
                    <span class="tag is-white">
                      画像削除
                      <button class="delete is-small" @click.prevent="delete_images"></button>
                    </span>
                  </div>
                </div>
                <div class="file">
                  <label class="file-label">
                    <input
                      class="file-input"
                      type="file"
                      name="resume"
                      @change="onFileChange"
                      accept=".jpg, .gif, .png, image/gif, image/jpeg, image/png"
                    />
                    <span class="file-cta">
                      <span class="file-icon">
                        <i class="fas fa-upload"></i>
                      </span>
                      <span class="file-label" v-if="imageSrc">画像を変更</span>
                      <span class="file-label" v-else>画像を選択</span>
                    </span>
                  </label>
                </div>
              </div>
              <div class="field"></div>
            </div>
          </div>
          <!-- 5行目 end -->
          <!-- 6行目 -->
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">掲載期間</label>
            </div>
            <div class="field-body">
              <div class="field is-grouped">
                <p class="control">
                  <flat-pickr
                    v-model="inputForm.from_date"
                    :config="config.from"
                    class="input"
                    placeholder="開始日"
                    v-bind:disabled="inputForm.isNotPostingTerm"
                  ></flat-pickr>
                </p>
                <p class="control">
                  <span class="vertical-middle">～</span>
                </p>
                <p class="control">
                  <flat-pickr
                    v-model="inputForm.to_date"
                    :config="config.to"
                    class="input"
                    placeholder="終了日"
                    v-bind:disabled="inputForm.isNotPostingTerm"
                  ></flat-pickr>
                </p>
                <div
                  class="h7 is-size-7 has-text-danger"
                  v-show="error.date"
                >※指定された日付が不正です。確認してください。</div>
              </div>
            </div>
          </div>
          <!-- 6行目 end -->
          <!-- 7行目 -->
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="lable"></label>
            </div>
            <div class="field-body">
              <div class="field">
                <label class="checkbox">
                  <input type="checkbox" v-model="inputForm.isNotPostingTerm" />
                  掲載期間を設定しない
                </label>
              </div>
            </div>
          </div>
          <!-- 7行目 end -->
          <!-- 8行目 -->
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="lable">登録者</label>
            </div>
            <div class="field-body">
              <div>
                <p class="control">
                  <input
                    class="input"
                    v-model="inputForm.register"
                    type="text"
                    placeholder="登録者"
                    required
                  />
                </p>
              </div>
            </div>
          </div>
          <!-- 8行目 end -->
          <!-- 9行目 -->
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="lable">編集者</label>
            </div>
            <div class="field-body">
              <div>
                <p class="control">
                  <input class="input" v-model="inputForm.editor" type="text" placeholder="編集者" />
                </p>
              </div>
            </div>
          </div>
          <!-- 9行目 end -->
          <div class="hero">
            <div class="field">
              <button type="submit" class="button is-medium is-rounded is-success">登録</button>
              &nbsp;&nbsp;
              <button
                class="button is-link is-size-5 is-rounded"
                @click.prevent="$router.go(-1)"
              >戻る</button>
            </div>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
const moment = require("moment");
import { mapGetters, mapActions, mapState } from "vuex"; //Vuex が提供する mapState 関数を使う
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
// try more themes at - https://chmln.github.io/flatpickr/themes/
import "flatpickr/dist/themes/material_blue.css";
// localization is optional
import { Japanese } from "flatpickr/dist/l10n/ja.js";
const THUMBNAIL_WIDTH = 1440; // 画像リサイズ後の横の長さの最大値
const THUMBNAIL_HEIGHT = 1080; // 画像リサイズ後の縦の長さの最大値
import $ from "jquery";
var image = new Image();
import { VueEditor } from "vue2-editor";

export default {
  data() {
    return {
      title: "",
      isEdit: false,
      inputForm: {
        id: null,
        mode: null,
        from_date: null,
        to_date: null,
        title: "",
        group: "0",
        category: "0",
        letter: "",
        image: null,
        imageDelete: null,
        isNotPostingTerm: null,
        register: "",
        editor: "",
      },
      imageSrc: null,
      config: {
        from: {
          altFormat: "Y-M-j",
          dateFormat: "Y-m-d",
          locale: Japanese,
          maxDate: null,
        },
        to: {
          altFormat: "Y-M-j",
          dateFormat: "Y-m-d",
          locale: Japanese,
          minDate: null,
        },
      },
      error: {
        group: null,
        category: null,
        date: null,
      },
      customToolbar: [[{ color: [] }], ["video"]],
    };
  },
  components: {
    flatPickr,
    VueEditor,
  },
  watch: {
    "inputForm.group": function (val) {
      this.$set(this.inputForm, "category", "0");
      this.categorySet(val);
    },
    "inputForm.from_date": function (val) {
      this.config.to.minDate = val;
      // this.$set( this.config, 'to.minDate', val)   //なぜかこれは動かない...
    },
    "inputForm.to_date": function (val) {
      this.config.from.maxDate = val;
    },
    "inputForm.isNotPostingTerm": function () {
      this.$set(this.inputForm, "from_date", moment().format("YYYY-MM-DD"));
      this.$set(
        this.inputForm,
        "to_date",
        moment().add(1, "day").format("YYYY-MM-DD")
      );
    },
  },
  computed: {
    ...mapGetters({
      groups: "news/groups",
      categorys: "news/categorys",
    }),
    ...mapState({
      apiStatus: (state) => state.news.apiStatus,
      isErrors: (state) => state.news.errorMessages,
      item: (state) => state.status.news_edit_item,
    }),
  },
  created() {
    this.clearError();
  },
  async mounted() {
    await this.$store.dispatch("news/newsGroupAndCategory");
    const mode = Number(this.$route.query.mode);
    if (this.apiStatus) {
      if (mode === 1) {
        this.title = "お知らせ編集";
        //編集
        this.$set(this.inputForm, "id", this.item.id);
        this.$set(this.inputForm, "mode", mode);
        this.$set(this.inputForm, "from_date", this.item.from_date);
        this.$set(this.inputForm, "to_date", this.item.to_date);
        this.$set(this.inputForm, "title", this.item.title);
        this.$set(this.inputForm, "group", this.item.group_id);
        this.$set(this.inputForm, "letter", this.item.letter);
        this.$set(
          this.inputForm,
          "isNotPostingTerm",
          this.item.isNotPostingTerm
        );
        this.$set(this.inputForm, "register", this.item.register);
        this.imageSrc = this.item.image;
      } else if (mode === 2) {
        this.title = "お知らせ引用";
        //編集
        this.$set(this.inputForm, "mode", mode);
        this.$set(this.inputForm, "from_date", this.item.from_date);
        this.$set(this.inputForm, "to_date", this.item.to_date);
        this.$set(this.inputForm, "title", this.item.title);
        this.$set(this.inputForm, "group", this.item.group_id);
        this.$set(this.inputForm, "letter", this.item.letter);
        this.$set(this.inputForm, "from_date", moment().format("YYYY-MM-DD"));
        this.$set(
          this.inputForm,
          "to_date",
          moment().add(1, "day").format("YYYY-MM-DD")
        );
        this.$set(this.config, "from.maxDate", this.inputForm.to_date);
        this.$set(this.config, "to.minDate", this.inputForm.from_date);
      } else {
        this.title = "新規お知らせ登録";
        //新規
        this.$set(this.inputForm, "from_date", moment().format("YYYY-MM-DD"));
        this.$set(
          this.inputForm,
          "to_date",
          moment().add(1, "day").format("YYYY-MM-DD")
        );
        this.$set(this.config, "from.maxDate", this.inputForm.to_date);
        this.$set(this.config, "to.minDate", this.inputForm.from_date);
      }
    }
  },
  methods: {
    ...mapActions({
      setCategory: "news/filCategorys",
    }),
    //グループが変更されたとき呼ばれる
    categorySet(key) {
      this.setCategory(key);
      //編集・引用モードの際にinputForm.groupを設定したときにcategoryの初期化が走ってしまうことへの対応
      if (this.inputForm.mode && !this.isEdit) {
        this.isEdit = true;
        this.$set(this.inputForm, "category", this.item.category_id);
      }
    },
    clearError() {
      this.$store.commit("news/setErrorMessages", null);
    },
    //データの送信
    async onSubmit() {
      const mode = this.$route.query.mode ? Number(this.$route.query.mode) : 0;
      this.clearError();
      //初期化
      Object.keys(this.error).forEach((key) => {
        this.$set(this.error, key, null); //https://012-jp.vuejs.org/guide/best-practices.html
      });
      if (!this.isValidation()) return false;
      if (mode === 1) {
        //編集API
        await this.$store.dispatch("news/editNews", this.inputForm);
      } else {
        //新規登録AIP
        await this.$store.dispatch("news/createNews", this.inputForm);
      }
      if (this.apiStatus) {
        //ページの切り替え
        this.$router.replace("/"); //戻る処理の対応
        this.$router.push({ name: "Confirmation", query: { mode: mode } });
      }
    },
    isValidation() {
      //グループのバリデーション
      if (this.inputForm.group === "0") {
        this.$set(this.error, "group", true);
        return false;
      }
      //カテゴリのバリデーション
      if (this.inputForm.category === "0") {
        this.$set(this.error, "category", true);
        return false;
      }
      //日付のバリデーション
      if (!this.inputForm.isNotPostingTerm) {
        if (this.inputForm.from_date === "" || this.inputForm.to_date === "") {
          this.$set(this.error, "date", true);
          return false;
        }
      }
      return true;
    },
    //画像ファイルの添付
    onFileChange(el) {
      this.inputForm.imageDelete = null;
      this.$store.commit("loading/setLoadingStatus", {
        loading: true,
        message: "画像取得中...",
      });
      const file = el.target.files || el.dataTransfer.files;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.imageSrc = e.target.result;
        //画像のリサイズ実行
        this.resizeImage(e.target.result);
      };
      reader.readAsDataURL(file[0]);
    },
    resizeImage(strBase64) {
      // 画像をリサイズする
      const _this = this;
      image.onload = function () {
        var width, height;
        if (image.width > image.height) {
          // 横長の画像は横のサイズを指定値にあわせる
          width = THUMBNAIL_WIDTH;
          height = THUMBNAIL_WIDTH * (image.height / image.width);
        } else {
          // 縦長の画像は縦のサイズを指定値にあわせる
          width = THUMBNAIL_HEIGHT * (image.width / image.height);
          height = THUMBNAIL_HEIGHT;
        }
        // サムネ描画用canvasのサイズを上で算出した値に変更
        var canvas = $("<canvas>").attr("width", width).attr("height", height);
        var ctx = canvas[0].getContext("2d");
        // canvasにサムネイルを描画
        ctx.drawImage(
          image,
          0,
          0,
          image.width,
          image.height,
          0,
          0,
          width,
          height
        );
        // canvasからbase64画像データを取得
        // var base64 = canvas.get(0).toDataURL('image/jpeg')
        _this.$set(
          _this.inputForm,
          "image",
          canvas.get(0).toDataURL("image/jpeg").replace(/^.*,/, "")
        );
        _this.$store.commit("loading/clearLoading");
      };
      image.src = strBase64;
    },
    delete_images() {
      this.inputForm.image = null;
      this.imageSrc = null;
      this.inputForm.imageDelete = "deleted";
    },
  },
};
</script>

<style scoped>
.hero {
  text-align: center;
}
.file {
  margin-top: 5px;
}
.vertical-middle {
  position: absolute;
  top: 50%; /*親要素を起点に上から50%*/
  left: 50%; /*親要素を起点に左から50%*/
  transform: translateY(-50%) translateX(-50%); /*要素の大きさの半分ずつを戻す*/
  -webkit-transform: translateY(-50%) translateX(-50%);
}
</style>
